import { EnvConfig } from '@shared/definitions';

export const environment: EnvConfig = {
  featureFlags: {},
  production: true,
  staging: false,
  development: false,
  api: 'https://admin.survey.digilize.nl',
  surveyStartUrl: 'https://survey.digilize.nl/survey',
  facebookAppId: '',
  instrumentationKey: 'faef185f-9df6-4582-b6c6-c10e24c7ade6',
  recaptchaSiteKey: '6LdIsqMlAAAAAE1IcI_JQR4UWTfTyDaVJorB4-Qx',
};
